import AppSettings from "lib/services/AppSettings";
import BaseDecorator from "./BaseDecorator";
import CompanyDecorator from "./CompanyDecorator";

export default class AgentCooperationDecorator extends BaseDecorator {
  static get pricing_type_options() {
    return AppSettings.agent_cooperation_pricing_type_options;
  }

  transformData(data) {
    return super.transformData({
      ...data,
      supplier: new CompanyDecorator(data.supplier),
      agent: new CompanyDecorator(data.agent),
    });
  }

  get active() {
    return this.enabled_by_supplier && this.enabled_by_agent;
  }

  get pricing_type_i18n() {
    return this.pricing_type && I18n.humanAttributeName("agent_cooperation", this.pricing_type);
  }

  get pricing_options() {
    return this.constructor.pricing_type_options[this.pricing_type];
  }

  get price_readable_by_supplier() {
    return this.pricing_options ? this.pricing_options.price_readable_by_supplier : false;
  }
  get price_manageable_by_supplier() {
    return this.pricing_options ? this.pricing_options.price_manageable_by_supplier : false;
  }
  get price_readable_by_agent() {
    return this.pricing_options ? this.pricing_options.price_readable_by_agent : false;
  }
  get price_manageable_by_agent() {
    return this.pricing_options ? this.pricing_options.price_manageable_by_agent : false;
  }
  get commision_readable_by_supplier() {
    return this.pricing_options ? this.pricing_options.commision_readable_by_supplier : false;
  }
  get commision_manageable_by_supplier() {
    return this.pricing_options ? this.pricing_options.commision_manageable_by_supplier : false;
  }
  get commision_readable_by_agent() {
    return this.pricing_options ? this.pricing_options.commision_readable_by_agent : false;
  }
  get commision_manageable_by_agent() {
    return this.pricing_options ? this.pricing_options.commision_manageable_by_agent : false;
  }
  get commision_includes_product_options_amount() {
    return this.pricing_options ? this.pricing_options.commision_includes_product_options_amount : false;
  }
  get service_fee_readable_by_supplier() {
    return this.pricing_options ? this.pricing_options.service_fee_readable_by_supplier : false;
  }
  get service_fee_manageable_by_supplier() {
    return this.pricing_options ? this.pricing_options.service_fee_manageable_by_supplier : false;
  }
  get service_fee_readable_by_agent() {
    return this.pricing_options ? this.pricing_options.service_fee_readable_by_agent : false;
  }
  get service_fee_manageable_by_agent() {
    return this.pricing_options ? this.pricing_options.service_fee_manageable_by_agent : false;
  }
  get service_fee_includes_product_options_amount() {
    return this.pricing_options ? this.pricing_options.service_fee_includes_product_options_amount : false;
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/AgentCooperationDecorator.js